import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingDisabledEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'BookingDisabledEvent';
}
